import { Component} from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, ToastController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';
// import { Camera, CameraOptions } from '@ionic-native/camera';

import { LoginPage } from '../login/login';
// import { ApplypointlistPage } from '../applypointlist/applypointlist';

/**
 * Generated class for the ApplypointPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-applypoint',
  templateUrl: 'applypoint.html',
})
export class ApplypointPage {
    loginId: string;
	api_key: string;
	version: string;

    from: string;
	wallet_address: string;
	bank: string;
	address: string;
	balance: any = [];
	value_list: any = [];

	value: string = '';
    coin_unit: string;
    unit: string;
	// target_wallet_address: string;
    
    texts: any = [];
	language : string;
	imagePath:string;

    isSend : boolean = true;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private http: HttpService,
		public modalCtrl: ModalController,
		public alertCtrl:AlertController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
		public app: App
		) {
			// this.target_wallet_address = "";
			// this.value = "";
            this.from = navParams.get("from");
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "withdrawalcoin");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
        this.coin_unit = localStorage.getItem("coin_unit");
        this.unit = localStorage.getItem("unit");
        
		this. _init();
        
        this._get_texts();       

	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).applypoint;
	}

    _changeValue() {
        if(this.value == "") {
            return;
        }

        let url = "deposit/approve/index/confirm";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version,
            value: this.value
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
				this.value = res.value;
				
				// this.floor();
			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
                this.value = "";
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
			
		},(err)=>{	
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: err,
				buttons: ['OK']
			});
			alert.present();
		
		});
    }

	_Send(){
        // let alert = this.alertCtrl.create({
        //     message: this.texts.alertM_ready,
        //     buttons: ['OK']
        // });
        // alert.present();

		this.isSend = false;

		if (!this.value || this.value.length == 0 || this.value =="0") {
			const toast = this.toastCtrl.create({
				message:  this.texts.toastM_amount,
				duration: 2000,
				position: 'middle'
			});
            toast.present();
            this.isSend = true;
			return false;
		}
		
		let url = "deposit/approve/index/save";
        let send_data = JSON.stringify({ 
            api: this.api_key,
            language: this.language,
            version: this.version,
            value: this.value,
            
        });
        this.http.post(url, send_data).then((res: any) => {
            if (res.result == "OK") {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();

                this.isSend = true;
                this.navCtrl.pop();

            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);
                this.isSend = true;
            
            } else {
                let alert = this.alertCtrl.create({
                    // title: '<span class="fail"> Fail </span>',
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                this.isSend = true;
            }
        },(err)=>{	
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
            this.isSend = true;
        });
	}

    _init() {
		//// 서버로부터의 데이타
        let url = "deposit/approve";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
				this.balance = res.balance;
				
                if (res.value != undefined) {   
                    this.value_list = res.value;
                }
				
				// this.floor();
			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
                this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
			
		},(err)=>{	
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: err,
				buttons: ['OK']
			});
			alert.present();
		
		});
	}
	
	// onTlist() {
    //     if (this.from == 'list') {
    //         this.navCtrl.pop();

    //     } else {
    //         this.navCtrl.push(ApplypointlistPage);

    //     }
	// }
}



// WEBPACK FOOTER //
// ./src/pages/applypoint/applypoint.ts